import type {ReactElement} from 'react';
import {DesignPageSelector} from '@Panels/design-page-selector/design-page-selector';
import {noop} from '@Utils/general.util';
import type {DesignPageSelectorOpts} from '@Panels/design-page-selector/design-page-selector.types';
import { PageSelectorSize, SelectionLimitBehavior} from '@Panels/design-page-selector/design-page-selector.types';
import {DisplayType} from '@Panels/poster-publishing-options-panel/poster-publishing-options-panel.types';
import {handleBackButtonClick} from '@Panels/poster-publishing-options-panel/poster-publishing-options-slice';
import {useAppDispatch} from '@/hooks';

export interface PublishingEmailCampaignPanelProps {
  posterId: string;
  onSubmit?: (selectedPageIds: string[]) => void;
  onClose?: () => void;
  className?: string;
  ctaText?: string;
  displayType?: DisplayType;
}

export function PublishingEmailCampaignPanel({
  posterId,
  onSubmit = noop,
  onClose = noop,
  className: propsClassName = '',
  displayType = DisplayType.DROPDOWN,
  ...props
}: PublishingEmailCampaignPanelProps): ReactElement | null {
  const dispatch = useAppDispatch();
  const PAGE_LIMIT = 1;

  const onSubmitPage = (pageHashedIds: string[]): void => {
    const pageIdToUse = pageHashedIds[0];

    if (!pageIdToUse) {
      // eslint-disable-next-line react-compiler/react-compiler
      window.location.href = window.PMW.util.site_url(`emailmarketing/publish/design/${posterId}`);
      return;
    }

    onSubmit([pageIdToUse]);
    window.location.href = window.PMW.util.site_url(`emailmarketing/publish/design/${posterId}/${pageIdToUse}`);
  };

  const getSelectionOptsForPanel = (): DesignPageSelectorOpts => {
    return {
      selectionLimitBehavior: SelectionLimitBehavior.DESELECT_FIRST,
      pageLimit: PAGE_LIMIT,
    } as DesignPageSelectorOpts;
  };

  const getClassesForDesignPageSelector = (): string => {
    let classNameToUse = propsClassName;

    if (displayType === DisplayType.DROPDOWN) {
      classNameToUse += ' spacing-p-t-0';
    }

    return classNameToUse;
  };

  const handleBackButton = (): void => {
    dispatch(handleBackButtonClick());
  };

  if (!window.PMW.enableMyStuffMultipagesUI) {
    onSubmitPage([]);
    return null;
  }

  return (
    <DesignPageSelector
      {...props}
      className={getClassesForDesignPageSelector()}
      posterId={posterId}
      onSubmit={onSubmitPage}
      selectionOpts={getSelectionOptsForPanel()}
      ctaText={window.i18next.t('pmwjs_publish')}
      headerTitle={window.i18next.t('pmwjs_select_a_page')}
      showBackButton
      onBackButton={handleBackButton}
      showCloseButton={displayType === DisplayType.MODAL}
      onClose={onClose}
      size={displayType === DisplayType.DROPDOWN ? PageSelectorSize.SMALL : PageSelectorSize.MEDIUM}
    />
  );
}
